<template>
  <div class="padding-10px">
    <el-card class="box-card" shadow="none" style="min-height: 500px;">
      <div slot="header" class="clearfix" style="display: flex; flex-direction: column">
        <el-row>
          <el-col :span="5">
            <div>
              <el-input placeholder="请输入搜索关键字" v-model="world" style="width: 97%;" size="medium" clearable>
              </el-input>
            </div>
          </el-col>
          <el-col :span="9">
            <div>
              <el-date-picker v-model="createTime" type="datetimerange" size="medium" range-separator="至"
                start-placeholder="开始日期" end-placeholder="结束日期" :editable="true" :clearable="true">
              </el-date-picker>
            </div>
          </el-col>
          <el-col :span="4">
            <div>
              <el-button type="primary" size="medium" icon="el-icon-search" @click="searchCarBrand">搜索</el-button>
            </div>
          </el-col>
          <el-col :span="2">&nbsp;</el-col>
          <el-col :span="4">
            <el-button type="success" size="medium" @click="openCarAddDialog(true, true, null)"
              v-if="checkButtonPermission('car:manage:brand:add')">新增品牌</el-button>
          </el-col>
        </el-row>
      </div>
      <div>
        <el-table :data="tableData" border style="width: 100%" min-height="350">
          <el-table-column prop="carBrandName" label="品牌名称"></el-table-column>
          <el-table-column prop="carBrandImage" label="品牌图片">
            <template slot-scope="scope">
              <img :src="scope.row.carBrandImage" min-width="32" height="32" />
            </template>
          </el-table-column>
          <el-table-column prop="label" label="品牌排序"></el-table-column>
          <el-table-column prop="createTime" label="时间" width="320"></el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button @click="openCarAddDialog(true, false, scope.row)" type="success" size="mini"
                v-if="checkButtonPermission('car:manage:brand:edit')">编辑
              </el-button>
              <el-button @click="deleteCarBrand(scope.row.carBrandId)" type="danger" size="mini"
                v-if="checkButtonPermission('car:manage:brand:delete')">删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <div style="margin: 18px 0px; float: right;">
          <el-pagination background @current-change="currentPageChange" @size-change="pageSizeChange"
            :current-page="currentPage" :page-sizes="[5, 10, 20, 50, 100]" :page-size="pageSize" :page-count="totalPage"
            layout="total, sizes, prev, pager, next, jumper" :total="total">
          </el-pagination>
        </div>
      </div>
    </el-card>
    <el-dialog :title="addCarBrandDialogTitle + '品牌'" :visible.sync="addCarBrandDialogVisible" :modal="false"
      :close-on-click-modal="false" @closed="resetForm('carBrandForm')">
      <el-form :model="carBrandForm" ref="carBrandForm" :rules="carBrandRules" label-width="120px" size="medium"
        @submit.native.prevent="submitCarBrandForm('carBrandForm')" style="padding: 0 10%;">
        <el-form-item label="品牌名称" prop="carBrandName">
          <el-input v-model="carBrandForm.carBrandName" clearable></el-input>
        </el-form-item>
        <el-form-item label="排序" prop="label">
          <el-input v-model="carBrandForm.label" clearable></el-input>
        </el-form-item>
        <el-form-item label="品牌图片" prop="carBrandImage">
          <el-upload :limit="1" :file-list="fileList" :action="this.env.env.uploadUrl" list-type="picture-card"
            :on-success="uploadBrandSuccess" :on-preview="uploadPreviewHandler" :on-remove="uploadRemoveHandler">
            <i class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>
        <el-form-item size="large">
          <el-button
            @click="addCarBrandDialogVisible = false">&nbsp;&nbsp;&nbsp;取&nbsp;&nbsp;消&nbsp;&nbsp;&nbsp;</el-button>
          <el-button type="primary"
            @click="submitCarBrandForm('carBrandForm')">&nbsp;&nbsp;&nbsp;确&nbsp;&nbsp;定&nbsp;&nbsp;&nbsp;</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog :visible.sync="uploadDialogVisible">
      <img width="100%" :src="carBrandForm.carBrandImage" alt="">
    </el-dialog>
  </div>
</template>

<script>
import { reqCode, dialogAction } from '@/common/const';
export default {
  name: "carBrandList",
  data() {
    return {
      world: '',
      createTime: [],
      tableData: [
        {
          carBrandName: '五菱宏光',
          carBrandImage: 'https://timgsa.baidu.com/timg?image&quality=80&size=b9999_10000&sec=1583475651228&di=00624c7624e0e700304f1be82294b659&imgtype=0&src=http%3A%2F%2Fimg.juimg.com%2Ftuku%2Fyulantu%2F121209%2F267868-12120919111323.jpg',
          createTime: '2020-03-06 21:00:00',
        },
      ],
      addCarBrandDialogVisible: false,
      addCarBrandDialogTitle: '新增',
      currentPage: 1,
      pageSize: 20,
      totalPage: 100,
      total: 100000,
      carBrandForm: {
        carBrandName: '',
        carBrandImage: '',
      },
      carBrandRules: {
        carBrandName: [{ required: true, message: '品牌名称不能为空', trigger: 'blur' }],
      },
      uploadDialogVisible: false,
      addFlag: true,
      fileList: [],
    }
  },
  created() {
    this.searchCarBrand();
  },
  methods: {
    uploadBrandSuccess(resp, file, list) {
      if (reqCode.SUCCESS == resp.code) {
        this.carBrandForm.carBrandImage = resp.data;
      } else {
        this.$message({
          message: '上传文件失败：' + resp.message,
          type: 'error'
        });
      }
    },
    openCarAddDialog(addCarBrandDialogVisible, addFlag, data) {
      this.addFlag = addFlag;
      if (addFlag == false) {
        this.addCarBrandDialogTitle = '编辑';
        let tmp = {};
        Object.assign(tmp, data);
        this.carBrandForm = tmp;
        let imgObj = new Object();
        imgObj.url = tmp.carBrandImage;
        this.fileList.push(imgObj);
      } else {
        this.addCarBrandDialogTitle = '新增';
      }
      this.addCarBrandDialogVisible = addCarBrandDialogVisible;
    },
    searchCarBrand() {
      let reqParam = {
        currentPage: this.currentPage,
        size: this.pageSize,
        startCreateTime: this.createTime[0],
        endCreateTime: this.createTime[1],
        carBrandName: this.world,
      };
      this.$http.post('/api/car/brand/list', reqParam, {
        headers: {
          accessToken: sessionStorage.getItem('accessToken')
        }
      }).then(resp => {
        console.log(resp);
        let pageInfo = resp.data.pageInfo;
        this.tableData = pageInfo.list;
        this.pageSize = pageInfo.pageSize;
        this.total = pageInfo.total;
        this.totalPage = pageInfo.pages;
      }).catch(response => {
        this.$alert('服务器发生异常，请联系开发者，这是错误信息：' + response, '错误提示', {
          confirmButtonText: '确定'
        });
      })
    },
    addCarBrand(formName, reqParam) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$http.post('/api/car/brand/add', reqParam, {
            headers: {
              accessToken: sessionStorage.getItem('accessToken')
            }
          }).then(resp => {
            this.$message({
              message: '成功新增一条品牌信息',
              type: 'success'
            });
            this.addCarBrandDialogVisible = false;
            this.resetForm('carBrandForm');
            this.searchCarBrand();
          }).catch(e => {

          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    editCarBrand(formName, reqParam) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$http.post('/api/car/brand/update', reqParam, {
            headers: {
              accessToken: sessionStorage.getItem('accessToken')
            }
          }).then(resp => {
            let data = resp.data;
            if (data.code === "success") {
              this.$message({
                message: '编辑品牌信息成功',
                type: 'success'
              });
              this.addCarBrandDialogVisible = false;
              this.searchCarBrand();
            } else {
              this.$alert('' + data.message, '温馨提示', {
                confirmButtonText: '确定'
              });
            }
          }).catch(e => {

          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    deleteCarBrand(carBrandId) {
      this.$http.post('/api/car/brand/delete?carBrandId=' + carBrandId, {}, {
        headers: {
          accessToken: sessionStorage.getItem('accessToken')
        }
      }).then(resp => {
        let data = resp.data;
        if (data.code === "success") {
          this.$message({
            message: '删除品牌信息成功',
            type: 'success'
          });
          this.addCarBrandDialogVisible = false;
          this.searchCarBrand();
        } else {
          this.$alert('' + data.message, '温馨提示', {
            confirmButtonText: '确定'
          });
        }
      }).catch(e => {

      })
    },
    currentPageChange(val) {
      this.currentPage = val;
      this.searchCarBrand();
    },
    pageSizeChange(val) {
      this.pageSize = val;
      this.searchCarBrand();
    },
    submitCarBrandForm(formName) {
      let reqParam = {
        carBrandName: this.carBrandForm.carBrandName,
        carBrandImage: this.carBrandForm.carBrandImage,
        label: this.carBrandForm.label,
      };

      if (this.addFlag) {
        this.addCarBrand(formName, reqParam);
      }

      else {
        reqParam.carBrandId = this.carBrandForm.carBrandId;
        this.editCarBrand(formName, reqParam);
      }

    },
    resetForm(formName) {
      this.carBrandForm = {};
      this.fileList = [];
      this.$refs[formName].resetFields();
    },
    uploadRemoveHandler() {

    },
    uploadPreviewHandler(file) {
      this.carBrandForm.carBrandImage = file.url;
      this.uploadDialogVisible = true;
    },
    checkButtonPermission(perms) {
      let menuPermsList = sessionStorage.getItem("menuPermsList");
      if (menuPermsList.indexOf(perms) != -1) {
        return true
      } else {
        return false;
      }
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/car/brand/carBrandList.vue